
<script>
export default {
  methods: {
    // notification
    redirectToNotification(notification) {
      this.redirectToEvent(notification.Event, notification);
    },
    redirectToTODOItem(todoItem) {
      this.redirectToEvent(todoItem.Event, todoItem);
    },
    redirectToEvent(event, obj) {
      if (event.ItemType == "project") {
        this.redirectToProject(event.ItemID);
      } else if (event.ItemType == "taskWorkingItem") {
        this.redirectToTaskWorkingItem(event.ItemID);
      } else if (event.ItemType == "task") {
        let task = this.$store.state.task.list.find(o => o.ID == event.ItemID);
        if (!task) {
          window.console.error(
            `redirectToEvent, but task not found (${event.ItemID})`
          );
          return;
        }
        this.redirectToProjectTaskTab(task.ProjectID);
      } else if (event.ItemType == "projectDepartmentBudget") {
        let projectDepartmentBudget = this.$store.state.projectDepartmentBudget.list.find(
          o => o.ID == event.ItemID
        );
        if (!projectDepartmentBudget) {
          window.console.error(
            `redirectToEvent, but projectDepartmentBudget not found (${event.ItemID})`
          );
          return;
        }
        this.redirectToProjectTaskTab(projectDepartmentBudget.ProjectID);
      } else if (event.ItemType == "user") {
        this.redirectToUser(event.ItemID);
      } else if (event.ItemType == "county") {
        this.redirectToCounty(event.ItemID);
      } else if (event.ItemType == "client") {
        this.redirectToClient(event.ItemID);
      } else if (event.ItemType == "department") {
        this.redirectToDepartment(event.ItemID);
      } else if (event.ItemType == "workOrder") {
        this.redirectToWorkOrder(event.ItemID);
      } else if (event.ItemType == "leaveForm") {
        this.redirectToLeaveForm(event.ItemID);
      } else if (event.ItemType == "compensatoryTime") {
        this.redirectToCompensatoryTime(event.ItemID);
      } else {
        window.console.error(
          `redirectToNotification, unknown event type ${event.ItemType}`,
          event,
          obj
        );
      }
    },
    redirectToProject(id) {
      // this.$router.push(`/project?id=${id}`);
      this.$store.state.UI.dialog.project.id = id;
      this.$store.state.UI.dialog.project.isShow = true;
    },
    // 任務
    redirectToProjectTaskTab(projectID) {
      // this.$router.push(`/project?id=${projectID}#tasks`);
      this.$store.state.UI.dialog.project.defaultOpenTaskTab = true;
      this.$store.state.UI.dialog.project.id = projectID;
      this.$store.state.UI.dialog.project.isShow = true;
    },
    // 工作日誌
    redirectToTaskWorkingItem(id) {
      // this.$router.push(`/work-log`);
      this.$store.state.UI.dialog.taskWorkingItemDetail.id = id;
      this.$store.state.UI.dialog.taskWorkingItemDetail.isShow = true;
    },
    // redirectToTaskWorkingItemInProject 檢視專案時檢視工作日誌。不要出現「檢視專案」按鈕
    redirectToTaskWorkingItemInProject(id) {
      this.$store.state.UI.dialog.taskWorkingItemDetailInProject.id = id;
      this.$store.state.UI.dialog.taskWorkingItemDetailInProject.isShow = true;
    },
    // 使用者
    redirectToUser(id) {
      this.$router.push(`/management/user?id=${id}`);
    },
    // 客戶
    redirectToCounty(id) {
      this.$router.push(`/management/county`);
    },
    // 地區
    redirectToClient(id) {
      this.$router.push(`/management/client`);
    },
    // 部門
    redirectToDepartment(id) {
      this.$router.push(`/management/department`);
    },
    // 工單
    redirectToWorkOrder(id) {
      // this.$router.push(`/work-order`);
      this.$store.state.UI.dialog.workOrderDetail.id = id;
      this.$store.state.UI.dialog.workOrderDetail.isShow = true;
    },
    // 假單
    redirectToLeaveForm(id) {
      // this.$router.push(`/travel`);
      this.$store.state.UI.dialog.leaveFormDetail.id = id;
      this.$store.state.UI.dialog.leaveFormDetail.isShow = true;
    },
    // 補休
    redirectToCompensatoryTime(id) {
      // this.$router.push(`/compensatory-time`);
      this.$store.state.UI.dialog.compensatoryTimeDetail.id = id;
      this.$store.state.UI.dialog.compensatoryTimeDetail.isShow = true;
    }
    // 公告
  }
};
</script>
